export const moduleSlug = "PROXY_MANAGER";

export const PROXY_MANAGER_ITEMS_PER_PAGE = "50";

export default { moduleSlug };
